import React from 'react'
import "./Closefriend.css"
function Closefriend() {
  return (
    <div>
       <li className="sidebarFriend">
                <img className='sidebarFriendImg' src="./assets/haseeb_edited_edited.jpg" alt="error" />
                <span className="sidebarFriendName">haseeb</span>
            </li>
    </div>
  )
}

export default Closefriend
